import qs from 'query-string'
import api from '../../api'
import { TIMEOUT, TERMS_ADAPTER as ADAPTER } from "../../constants"
import { errorHandler as catcher, generateRequestHeaders } from '../../utils'
import Axios from 'axios'

const handlePost = async (key, requestBody) => {
  return new Promise(function(resolve, reject){
    const url = api.base+api[key]

    Axios.post(url, requestBody, getConfig())
      .then(res => resolve(resolver(res)))
      .catch(err => reject(catcher(err)));
  })
}

const apiService = {
  async getFromPathReport(path, options) {
    return new Promise(function(resolve, reject){
      const queryObject = convertOptionsToQueryObject(options, ADAPTER)
      const stringified = qs.stringify(queryObject)
      const querystring = `${stringified !== '' ? '?'+stringified : ''}`
      const url = `${api.report}${path}${querystring}`

      Axios.get(url, getConfig())
        .then(res => resolve(resolver(res)))
        .catch(err => reject(catcher(err)));
    })
  },
  async getFromPath(path, options) {
    return new Promise(function(resolve, reject){
      const queryObject = convertOptionsToQueryObject(options, ADAPTER)
      const stringified = qs.stringify(queryObject)
      const querystring = `${stringified !== '' ? '?'+stringified : ''}`
      const url = `${api.base}${path}${querystring}`

      Axios.get(url, getConfig())
        .then(res => resolve(resolver(res)))
        .catch(err => reject(catcher(err)));
    })
  },

  async get(key, options) {
    return new Promise(function(resolve, reject){
      const queryObject = convertOptionsToQueryObject(options, ADAPTER)
      const stringified = qs.stringify(queryObject)
      const querystring = `${stringified !== '' ? '?'+stringified : ''}`
      const url = `${api.base}${api[key]}${querystring}`

      Axios.get(url, getConfig())
        .then(res => resolve(resolver(res)))
        .catch(err => reject(catcher(err)));
    })
  },

  async getStatistic(key, options) {
    return new Promise(function(resolve, reject){
      const queryObject = convertOptionsToQueryObject(options, ADAPTER)
      const stringified = qs.stringify(queryObject)
      const querystring = `${stringified !== '' ? '?'+stringified : ''}`
      const url = `${api.report}${api[key]}${querystring}`

      Axios.get(url, getConfig())
        .then(res => resolve(resolver(res)))
        .catch(err => reject(catcher(err)));
    })
  },

  async getById(key, id){
    return new Promise(function(resolve, reject){
      Axios.get(`${api.base}${api[key]}${id}/`, getConfig())
        .then(res => resolve(resolver(res)))
        .catch(err => reject(catcher(err)))
    })
  },

  async create(key, requestBody){
    return new Promise(function(resolve, reject){
      const url = api.base+api[key]

      Axios.post(url, requestBody, getConfig())
        .then(res => resolve(resolver(res)))
        .catch(err => reject(catcher(err)));
    })
  },

  post: handlePost,

  async update(key, id, requestBody){
    return new Promise(function(resolve, reject){
      const url = `${api.base}${api[key]}${id ? id+'/' : ''}`

      Axios.put(url, requestBody, getConfig())
        .then(res => resolve(resolver(res)))
        .catch(err => reject(catcher(err)));
    })
  },

  async delete(key, id){
    return new Promise(function(resolve, reject){
      Axios.delete(`${api.base}${api[key]}${id}/`, getConfig())
        .then(res => resolve(resolver(res)))
        .catch(err => reject(catcher(err)))
    })
  },
}

// Helpers
function getConfig(){
  return {
    timeout: TIMEOUT,
    headers: generateRequestHeaders()
  }
}

function resolver(res){
  return (res.data ? res.data : res)
}

function convertOptionsToQueryObject(options, ADAPTER){
  let query = {}

  if(options){
    const keys = Object.keys(ADAPTER)

    for (let index = 0; index < keys.length; index++) {
      const key = keys[index];

      if(options[key]){
        query[ADAPTER[key]] = options[key]
      }
    }
  }

  return query
}

export default apiService
